import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarCategoriasLCPDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class CategoriasLCPBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Categorias LCP">
                    <DataGrid
                        dataSource={criarCategoriasLCPDs()}
                        showBorders={true}
                        rowAlternationEnabled={true} remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'norma'} caption={"Norma"} width={'120'}/>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
